"use client";

import dynamic from "next/dynamic";

// Heavy Web Audio component — load client-side only
const DJMixer = dynamic(
  () => import("@/components/dj/dj-mixer"),
  { ssr: false, loading: () => (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <p className="text-muted-foreground animate-pulse">Loading DJ Mixer…</p>
      </div>
    )
  }
);

export default function DJPage() {
  return <DJMixer />;
}
